import defaultImg from '@/assets/syLog.png';
import qrCodeImg from '@/assets/qrCode.jpg';

// 点餐宝
import dcbLog from '@/assets/jsb/dcbLog.png';
import dcbCode from '@/assets/jsb/dcbCode.png';
// 叫号宝
import jhbLog from '@/assets/jsb/jhbLog.png';
import jhbCode from '@/assets/jsb/jhbCode.png';
// 排队宝
import pdbLog from '@/assets/jsb/pdbLog.png';
import pdbCode from '@/assets/jsb/pdbCode.png';
// 配送宝
import psbLog from '@/assets/jsb/psbLog.png';
import psbCode from '@/assets/jsb/psbCode.png';
// 掌中宝
import zzbLog from '@/assets/jsb/zzbLog.png';
import zzbCode from '@/assets/jsb/zzbCode.png';
// 平板点餐
import pbdcLog from '@/assets/jsb/pbdcLog.png';
// import pbdcCode from '@/assets/jsb/pbdcCode.png';
// KDS
import kdsLog from '@/assets/jsb/kdsLog.png';
import kdsCode from '@/assets/jsb/kdsCode.png';
let btn = [
	{
			id: 1,
			img: defaultImg,
			tit: '聚收宝收银',
			introduce: '聚收宝收银系统Windows客户端',
			tip: 'win版',
			btn: [{
					tit: '复制下载链接',
					textColor: '#ff690e',
					border: '1px solid #ff690e',
					copyUrl: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2023/11/10/05d21c1b5b7545d08bed82d62a5535b4.exe',
				},
				{
					tit: '点我下载',
					bgColor: '#FF690E',
					downloadUrl: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2023/11/10/05d21c1b5b7545d08bed82d62a5535b4.exe',
				},
			],
		},
		{
			id: 2,
			img: dcbLog,
			tit: '点餐宝',
			introduce: '支持手机开台点餐，快速收款',
			tip: '安卓版',
			btnAndroid: true,
			btn: {
				bgColor: '#FF690E',
				AndroidText: '打开浏览器扫码下载',
				Url: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2023/11/10/81d1cecb77ad49819005e0da72f04b14.apk',
				img:''
			},
		},
		{
			id: 3,
			img: jhbLog,
			tit: '叫号宝',
			introduce: '支持排队叫号，有序就餐',
			tip: '安卓版',
			btnAndroid: true,
			btn: {
				bgColor: '#FF690E',
				AndroidText: '打开浏览器扫码下载',
				Url: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2023/11/10/3f85861093ef4f32bc8dbd5acd7be8dd.apk',
				img:''

			},
		},
		{
			id: 4,
			img: pdbLog,
			tit: '排队宝',
			introduce: '支持排队叫号，有序就餐',
			tip: '安卓版',
			btnAndroid: true,
			btn: {
				bgColor: '#FF690E',
				AndroidText: '打开浏览器扫码下载',
				Url: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2023/11/10/d116b3d0f61546138008ac28728686f6.apk',
				img:''

			},
		},
		{
			id: 5,
			img: psbLog,
			tit: '配送宝',
			introduce: '支持手机自营外卖配送',
			tip: '安卓版',
			btnAndroid: true,
			btn: {
				bgColor: '#FF690E',
				AndroidText: '打开浏览器扫码下载',
				Url: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2023/11/10/81e1488d6678467b9e262e7495ee8e1c.apk',
				img:''

			},
		},
		{
			id: 6,
			img: zzbLog,
			tit: '掌中宝',
			introduce: '支持商品管理、收银报表、订单查询',
			tip: '安卓版',
			btnAndroid: true,
			btn: {
				bgColor: '#FF690E',
				AndroidText: '打开浏览器扫码下载',
				Url: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2023/11/10/bf48e383abbb4a0fbff06eae05ddea8b.apk',
				img:''

			},
		},
		{
			id: 7,
			img: pbdcLog,
			tit: '平板点餐',
			introduce: '专为平板设计的点餐APP，通过提供便捷、高效的点餐体验，提高顾客满意度和餐厅的运营效率',
			tip: '安卓版',
			btnAndroid: true,
			btn: {
				bgColor: '#FF690E',
				AndroidText: '打开浏览器扫码下载',
				Url: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2024/02/22/d45ca08a717f43fb91a6ed9fcd3a5122.apk',
				img:''
		
			},
		},
		{
			id: 8,
			img: kdsLog,
			tit: 'KDS',
			introduce: '需安装在安卓设备，用于划菜传菜等智能后厨操作，支持与最新版本的聚收宝收银（Win版和Android版均可）联动',
			tip: '安卓版',
			btnAndroid: true,
			btn: {
				bgColor: '#FF690E',
				AndroidText: '打开浏览器扫码下载',
				Url: 'https://yhbtest.oss-cn-shenzhen.aliyuncs.com/default/2024/02/22/971774c49b5342999e030ebffbe9e9dc.apk',
				img:''
			},
		},
]

export default btn